
export const config = {
    "URL": {
        //SOFR rate
        "submitSOFRRate":"/core-service/sofr-rate-configure-request",
        "fetchSOFRRate":"/core-service/sofr-rate-data",
        "fetchActiveSofrRate":"/core-service/active-sofr-rate",
        "submitDailySOFRRequestAction":"/core-service/daily-sofr-request-action",


        //portfolio
        "fetchPortfolioDetails": "/risk-service/portfolio/fetchPortfolio",
        "registeredAvailbleUsers":"/risk-service/portfolio/availableUsers",
        "calculatePortfolioData":"/risk-service/portfolio/run-batch",
        "fetchStatus":"/risk-service/portfolio/status",
        //MarginModel
        "submitMarginModel": "/core-service/margin-model/submitMarginModel",
        "submitMarginModelDetails": "/core-service/forex-forward/utilizedMargin",
        "fetchProductMaster": "/core-service/product-masters",

        //Spot rate upload list
        "uploadCurrencyQuote": "/core-service/fxFwdRate/upload-currency-quote",
        "submitCurrencyQuote": "/core-service/fxFwdRate/submit-currency-quote",
        "fetchCurrencyQuote": "/core-service/fxFwdRate/fetch-currency-quote",
        "fetchHistoricalCurrencyQuote": "/core-service/fxFwdRate/fetch-currency-quote-history",
        "submitCurrencyQuoteAction": "/core-service/fxFwdRate/approveCurrencyQuote",
        "fetchMarginModelJobInfo": "/core-service/fxFwdRate/margin-model-jobs-info",
        "calculateHsVar": "/core-service/fxFwdRate/margin/run",



        "submitProductMarginModel": "/core-service/product-margin-validity-request",
        "submitProductMarginActionModel": "/core-service/product-margin-request-action",
        "fetchMarginModels": "/core-service/product-margin-validity-data",
        "fetchEwmaScalingModel": "/core-service/margin-model-data",
        "submitEwmaMarginActionModel": "/core-service/margin-model-request-action",
        "submitEwmaMarginModel": "/core-service/margin-model-configure-request",



        //forex-frowards
        "fetchUtilizedMarginDetails": "/core-service/forex-forward/utilizedMargin",
        "submitCurrencyRate": "/core-service/currencyModel/saveCurrencyRate",
        "fetchMemberCollateralDetails": "/core-service/forex-forward/collateralDetails",
        "getCurrencyRate": "/core-service/currencyModel/findAll",
        "getCurrencyRateById": "/core-service/currencyModel/getCurrencyRate",
        "captchaURL": "/otc-security/login",
        "validateURL": "/otc-security/validateUser",
        "authenticateURL": "/otc-security/authenticateUser",
        "logoutURL": "/otc-security/logout-jwt-token",
        "generateOTPTokenURL": "/otc-2FA/sendOtp",
        "validateOTPTokenURL": "/otc-2FA/verifyOtp",
        "generateOTPURL": "/otc-2FA/passwordUpdation/sendOtp",
        "validateOTPURL": "/otc-2FA/passwordUpdation/verifyOtp",
        "forgotPasswordURL": "/otc-security/forgotPassword",
        "unlockAccountURL": "/otc-security/unlockUser",
        "changePasswordURL": "/otc-security/changePassword",
        "getDynamicFieldList": "/otc-security/getDynamicFieldList",
        "fetchRegisterRequests": "/otc-security/fetchRegisterRequests",
        "getUserDetails": "/otc-security/getUserMenus",
        "saveOrSubmitData": "/otc-security/saveOrSubmitData",
        "generateOTPReg": "/otc-2FA/register/sendOtp",
        "validateOTPReg": "/otc-2FA/register/verifyOtp",
        "getUserMenusDerivative": "/otc-security/getUserMenusDerivative",
        "uploadRegisterFile": "/otc-security/uploadRegisterFile",
        "downloadRegisterFile": "/otc-security/downloadRegisterFile",
        "makerCheckerAction": "/otc-security/makerCheckerAction",
        "saveUserMenuMappings": "/otc-security/saveUserMenuMappings",
        "userListURL": "/otc-security/getUsers",
        "addUserURL": "/otc-security/createUser",
        "updateUserURL": "/otc-security/updateUser",
        "getAutoPopulatedUserValues": "/otc-security/getAutoPopulatedUserValues",
        "validateEmailURL": "/otc-security/validateEmail",
        "fetchRegisterMaster": "/otc-security/getRegisterMaster",
        "getMemberMenus": "/otc-security/getMemberMenus",
        "saveMenuList": "/otc-security/saveMenuList",
        "checkLoginId": "/otc-security/checkLoginId",
        // forign Currency Options
        "saveSingleDealForeignCurOpt": "/core-service/foreignCurrency/saveSingleDeal",
        "getAllForeignCurOptDeals": "/core-service/foreignCurrency/getAllForeignCurOptDeals",
        "getCurrencyMaster": "/core-service/foreignCurrency/getCurMastrData",
        "getForeignCurOptPrmMastr": "/core-service/foreignCurrency/getForeignCurOptPrmMastr",
        "cancelCurncyOptDeal": "/core-service/foreignCurrency/cancelCurncyOptDeal",
        "getForeignCurOptDeal": "/core-service/foreignCurrency/getForeignCurOptDeal",
        "getMasterMemberIdAndName": "/core-service/getMasterMemberIdAndName",
        "getAllMatchedForeignCurOptDeals": "/core-service/foreignCurrency/getAllMatchedForeignCurOptDeals",
        "bulkUpload": "/core-service/strategy-Bulk-Deal-upload-csv",
        "getUploadedData": "/core-service/get-all-strategy-deals-list",
        "fetchPremiumPaymntDate": "/core-service/foreignCurrency/fetchPremiumPaymntDate",
        "checkHoliday": "/core-service/foreignCurrency/checkHoliday",
        "getCrncyOptFilterTrade": "/core-service/foreignCurrency/getCrncyOptFilterTrade",
        //Forward-swaps
        "uploadFsBulkFile": "/core-service/forwardSwap/uploadFsBulkFile",
        "getInterbankTrades": "/core-service/forwardSwap/searchInterbankTrades",
        "getInterbankDropDownData": "/core-service/forwardSwap/getInterbankDropDownData",
        "getClientDropDownData": "/core-service/forwardSwap/getClientDropDownData",
        "getCurrencyCodes": "/core-service/forwardSwap/getCurrencyCodes",
        "getClients": "/core-service/forwardSwap/getClients",
        "getClientTradesDeals": "/core-service/forwardSwap/searchClientTrades",
        "getCounterPartyList": "/core-service/forwardSwap/getCounterParties",
        "submitForwardSwaps": "/core-service/forwardSwap/submitForwardSwaps",
        "checkerActionClient": "/core-service/forwardSwap/checkForwardSwaps",
        // "getCounterPartyListInterbank": "/core-service/forwardSwap/getCounterPartyListInterbank",
        "uploadIntBankBulkFile": "/core-service/interbankswap/uploadInterbank",
        "submitTradesInterbank": "/core-service/interbankswap/submitInterbank",
        "cancelTradesInterbank": "/core-service/interbankswap/cancelFileUpload",
        "checkerActionInterbank": "/core-service/interbankswap/interbankCheckerApproval",
        "getStatsData": "/core-service/forwardSwap/getForwardSwapStats",
        //P-Note
        "getAnxrInstDetails": "/core-service/pnote/getAnxrInstDetails",
        "downloadSampleFile": "/core-service/pnote/downloadPnoteAnnexure",
        "uploadAnnexure": "/core-service/pnote/uploadPnoteAnnexure",
        // "getAnnexureADetailsList":"/core-service/pnote/getAnnexureADetailsList",
        "getSavedData": "/core-service/pnote/getSavedData",
        "getSubmittedAnnexureA": "/core-service/pnote/getSubmittedAnnexureA",
        "getCurrentMonthAnnexureMaster": "/core-service/pnote/getCurrentMonthAnnexureMaster",
        "uploadAnnexureBC": "/core-service/pnote/uploadAnxure",
        "getSubmittedPNotes": "/core-service/pnote/getSubmittedPNotes",
        "confirmPNoteAnnexureByMaker": "/core-service/pnote/confirmPnoteAnnexure",
        "confirmPNoteAnnexureByChecker": "/core-service/pnote/checkerConfirmationPnoteAnnexure",
        "deleteAnnexure": "/core-service/pnote/removePnoteAnnexure",
        "downloadPnoteAnnexureById": "/core-service/pnote/downloadPnoteAnnexureById",
        "getSubmissionDueDate": "/core-service/pnote/getSubmissionDueDate",
        "getPnoteTradeDataChart": "/core-service/pnote/fetchPnoteChartDetails",

        "getCounterPartyListInterbank": "/core-service/userDetails/getCounterPartyListInterbank",

        //IRS
        "submitIRS": "/core-service/IRS/saveInterestRateSwapTrade",
        "getIrsTrades": "/core-service/IRS/getIrsTrades",
        "getIrsTradeData": "/core-service/IRS/getIrsTradeData",
        "getAmrtAcrtSchedule": "/core-service/IRS/calculateAmrtAcrtSchedule",
        "getPaymentSchedule": "/core-service/IRS/calculateAmrtAcrtSchedule",
        "saveIRSAsDraft": "/core-service/IRS/saveIRSAsDraft",
        "getDraftIrsTrades": "/core-service/IRS/getDraftIrsTrades",
        "getDraftIrsTradeById": "/core-service/IRS/getDraftIrsTradeById",
        "cancelIRSTrade": "/core-service/IRS/cancelIRSTrade",
        "removeDraftIrsTrade": "/core-service/IRS/removeDraftIrsTrade",
        "getCurrencyBenchmarkRates": "/core-service/IRS/getCurrencyBenchmarkRates",
        //Client Registration
        "getClientCategory": "/core-service/clients/getClientCategory",
        "register": "/core-service/clients/register",
        "getRegisteredClients": "/core-service/clients/getClientsForMember",
        "clientApproveReject": "/core-service/clients/approveReject",
        "getClientsForSegment": "/core-service/clients/getClientsForSegment",
        //Parameter Master
        "saveHolidayMaster": "/core-service/parameters/upload-holiday-master",
        "uploadHolidayMaster": "/core-service/parameters/upload-holiday-master",

        "getHolidayMaster": "/core-service/parameters/getHolidayMaster",

        "getDailyIRSTradeData": "/core-service/IRS/getDailyTradeData",
        "getMonthlyTradeData": "/core-service/IRS/getMonthlyTradeData",

        //LEI master
        "getLEIMaster": "/core-service/forwardSwap/getLEIMaster",

        //SGrB
        "saveSgrbTrade": "/core-service/sgrb/saveTrade",
        "getAllSgrbTrades": "/core-service/sgrb/getAllSgrbTrades",
        "rejectSgrbTrade": "/core-service/sgrb/rejectSgrbTrade",
        "getSgrbTrade": "/core-service/sgrb/getSgrbTrade",
        "approveSgrbTrade": "/core-service/sgrb/approveSgrbTrade",
        "getSgrbFilteredTrade": "/core-service/sgrb/getSgrbFilteredTrade",

        //Trade report
        "saveOrSubmitTradeData": "/core-service/saveOrSubmitData",
        "getTradeDetailsById": "/core-service/getTradeDetails",
        "getAllTardes": "/core-service/getAllTrades",
        "getReportedTrades": "/core-service/getReportedTrades",

        //Commodity Report

        "searchCommodityTrade": "/core-service/commodity/trades/searchCommodityTrade",
        // changedafter
        "saveOrSubmitCommodityActionData": "/core-service/commodity/trades/action",
        "saveOrSubmitCommodityData": "/core-service/forex-forwards/trades/",
        "getCommodityDetailsById": "/core-service/commodity/trades/findByTradeId",
        // "getAllCommodity":"/core-service/getAllTradesCommodity",
        "getReportedCommodity": "/core-service/getReportedTradesCommodity",

        "fetchMarginPercentage": "/core-service/securityMargin/fetchMarginPercentage",
        "fetchMemberCollateral": "/core-service/securityMargin/fetchMemberCollateral",

        //forex-forwards
        "searchforexforwardTrade": "/core-service/forex-forward/searchForexForward",
        "saveOrSubmitforexforwardActionData": "/core-service/forex-forward/action",
        "saveOrSubmitforexforwardData": "/core-service/forex-forward/",
        "getforexforwardDetailsById": "/core-service/forex-forward/findByTradeId",
        // "getAllforex-forwards":"/core-service/getAllTradesforex-forwards",
        // "getReportedforex-forwards":"/core-service/getReportedTradesforex-forwards",


        //INR USD Forward rate
        "submitInrUsdDailyRate": "/core-service/fxFwdRate/forex-spot-rate-configure-request",
        "actionInrUsdDailyRate": "/core-service/fxFwdRate/forex-spot-rate-request-action",
        "fetchSpotRateData": "/core-service/fxFwdRate//forex-spot-rate-data",
        "uploadForexFwdInstRate": "/core-service/fxFwdRate/uploadForexFwdInstRate",
        "actionForexFwdInstRate": "/core-service/fxFwdRate/actionForexFwdInstRate",
        "searchForexFwdInstRate": "/core-service/fxFwdRate/searchForexFwdInstRate",






    },

    "data": {
        "passwordPattern": "((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@_]).{12,})",
        "passwordPolicy": "Password should contain atleast 1 lower case character, 1 upper case character, 1 numeric and 1 special character. Password Length should be minimum 12 characters. ",
        "userPattern": "^[a-zA-Z0-9@_]*$",
        "captchaPattern": "^[a-zA-Z0-9]*$",
        "panCardPattern": "^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$",
        "countryCodePattern": "^[0-9]{1,3}$",
        "mobileNoPattern": "^[0-9]{8,12}$",
        "gstNoPattern": "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}Z[a-zA-Z0-9]{1}$",
        "ifscCodePattern": "^[A-Z]{4}[a-zA-Z0-9]{7}$",
        "leiCodePattern": "^[A-Z0-9]{20}$",
        "userTypeData": [{ "id": 1, "name": "Admin" }, { "id": 2, "name": "Sub-user" }],
        "fileUploadURL": [
            "/otc-security/uploadRegisterFile", "/core-service/pnote/uploadPnoteAnnexure", "core-service/forwardSwap/uploadFsBulkFile", "/core-service/pnote/removePnoteAnnexure",
            "checkerConfirmationPnoteAnnexure", "/core-service/interbankswap/uploadInterbank", "/core-service/interbankswap/submitInterbank", "/core-service/interbankswap/cancelFileUpload", 
            "/core-service/fxFwdRate/uploadForexFwdInstRate", "/core-service/fxFwdRate/upload-currency-quote","core-service/parameters/upload-holiday-master",
        ],
        "days": ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY']
    },
    "successResponse": {
        "login": {
            "LOGIN_SUCCESS": "User logged in successfully",
            "OTP_SENT_TO_USER": "One time password (OTP) has been sent to registered mobile number & email address",
            "OTP_VALIDATE_SUCCESS": "OTP validated successfully",
            "PASSWORD_UPDATE_SUCCESS": "Your password is updated successfully",
            "UNLOCK_SUCCESS": "Your account is unlocked successfully"
        },
        "register": {
            "OTP_SENT_TO_USER": "One time password (OTP) has been sent to email address"
        },
        "user": {
            "ADD_USER_SUCCESS": "User added successfully",
            "UPDATE_USER_SUCCESS": "User details have been updated",
            "DELETE_USER_SUCCESS": "User deleted successfully",
            "ADD_MENU_SUCCESS": "Menu added successfully",
            "UPDATE_MENU_SUCCESS": "Menu details have been updated",
            "USER_ACCESS_SUCCESS": "User access details have been updated"
        }
    },
    "failureResponse": {
        "login": {
            "invalidCred": "Invalid credentials",
            "Invalid Credentials": "Invalid Credentials",
            "invalidCaptcha": "Invalid captcha. Please type the text displayed in image",
            "USER_DISABLED_MESSAGE": "Your Login ID is currently locked. Please click on \"Unlock Account\" link or contact System Administrator to unlock user",
            "IS_FIRST_TIME_LOGIN_MSG": "You have logged for the first time. Please change the password.",
            "USER_PASSWORD_EXPIRED": "Your password is expired. Please change the password.",
            "DEFAULT_PASSWORD": "You have logged in with the default password. Please change the password.",
            "PASSWORD_PRESENT_IN_HISTORY": "New password should not be same as last 5 passwords",
            "LOGGED_IN_OTHER_SYSTEM": "You have already logged in from other system.",
            "UNAUTHORIZED_USER": "You are not authorized to perform this operation",
            "OTP_FAILED": "Not able to send OTP. Please try again later",
            "OTP_DISABLED": "OTP is disabled for this user.",
            "INVALID_OTP": "Invalid OTP",
            "SERVICE_UNAVAILABLE": "Service is not available. Please try again later.",
            "OTP_DISABLED_TEMPORARYLY": "OTP is temporarily disabled. Please try again after some time."
        },
        "user": {
            "ADD_USER_FAIL": "Not able to add user",
            "UPDATE_USER_FAIL": "Not able to update user",
            "DELETE_USER_FAIL": "Not able to delete user",
            "ADD_MENU_FAIL": "Not able to add menu",
            "UPDATE_MENU_FAIL": "Not able to update menu",
            "USER_ACCESS_FAIL": "Not able to save user access details"
        },
        "SOMETHING_WENT_WRONG": "Something went wrong"
    },
    "dashboardMenu": [
        "pnote",
        "interestRateSwap"
    ],
    "secretKey": "NICCLOTC2025secretKey"

};
